module.exports = __webpack_public_path__ + "img/17.16f8e4f6.jpg";